import { I18n, TranslateOptions } from 'i18n-js'
import en from 'locales/translations/en.json'
import nl from 'locales/translations/nl.json'
import { TxKeyPath } from 'locales/i18n.types'

export enum Locales {
  English = 'en',
  Dutch = 'nl',
}

const defaultLocale = Locales.Dutch

export const i18n = new I18n(
  { en, nl },
  { defaultLocale, availableLocales: [Locales.English, Locales.Dutch], locale: Locales.Dutch }
)

export const translate = (key: TxKeyPath, options?: TranslateOptions): string => {
  return i18n.t(key, options)
}
